import ConsumerScan from './consumerScan.vue';

export default ConsumerScan;
